import { render, staticRenderFns } from "./PanasViewEmail.vue?vue&type=template&id=e512a4aa&scoped=true&lang=pug&"
import script from "./PanasViewEmail.vue?vue&type=script&lang=js&"
export * from "./PanasViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./PanasViewEmail.vue?vue&type=style&index=0&id=e512a4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e512a4aa",
  null
  
)

export default component.exports